// extracted by mini-css-extract-plugin
export default {"faqContent":"FAQ_faqContent__d3-55","faqItem":"FAQ_faqItem__RPlwJ","faqQuestion":"FAQ_faqQuestion__5936I","active":"FAQ_active__2M6wr","faqAnswer":"FAQ_faqAnswer__ykEOu"};